import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = {
  key: 0,
  class: "space-x-3 text-base font-semibold text-black",
  style: {"width":"150px"}
}
const _hoisted_3 = {
  key: 3,
  "data-dusk": "answer"
}

import FormSummaryTable from '@/custom/menicon/components/encounter-summary/FormSummaryTable.vue';
import FormSummaryGrid from '@/custom/menicon/components/encounter-summary/FormSummaryGrid.vue';
import { FormSummaryAnswerLayout } from '@/custom/menicon/models';
import { BaseIcon } from '@/lib/components';
import { i18n } from '@/i18n/i18n';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSummaryQuestion',
  props: {
  question: {
    type: String,
    required: true
  },
  value: {
    type: [Object, String, Array],
    default: null
  },
  type: {
    type: String as PropType<FormSummaryAnswerLayout>,
    default: 'string',
    validator: (value: string) => ['table', 'grid', 'string'].includes(value)
  },
  display: {
    type: String,
    default: 'row',
    validator: (value: string) => ['row', 'column'].includes(value)
  },
  lineClass: {
    type: String,
    default: ''
  },
  questionClass: {
    type: String,
    default: 'text-sm font-medium text-gray-500'
  },
  laterality: {
    type: String,
    default: null
  },
  locale: {
    type: String,
    default: i18n.global.locale.value
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.laterality)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.laterality !== 'spacer')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(BaseIcon), {
                  name: `${__props.laterality}-eye${__props.laterality === 'both' ? 's' : ''}`,
                  stroke: false
                }, null, 8, ["name"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`platform.eyes.${__props.laterality}-eye${__props.laterality === 'both' ? 's' : ''}`, [], {locale: __props.locale})), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-grow", [__props.display === 'row' ? 'grid grid-cols-2 gap-x-2 w-full' : 'flex flex-col space-y-2', __props.lineClass]])
    }, [
      (__props.question)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(__props.questionClass)
          }, _toDisplayString(__props.question), 3))
        : _createCommentVNode("", true),
      (__props.type === 'table')
        ? (_openBlock(), _createBlock(FormSummaryTable, {
            key: 1,
            columns: __props.value?.columns,
            rows: __props.value?.rows,
            locale: __props.locale,
            border: __props.value?.border
          }, null, 8, ["columns", "rows", "locale", "border"]))
        : (__props.type === 'grid')
          ? (_openBlock(), _createBlock(FormSummaryGrid, {
              key: 2,
              value: __props.value
            }, null, 8, ["value"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.value), 1)),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})